// Generated by CoffeeScript 2.7.0
var Flow;

import Ajax from 'libs/ajax.js';

import Hierarchy from 'libs/hierarchical-tree.js';

import BaseModel from '../base_model.js';

import Fieldable from '../concerns/fieldable.js';

import Vertex from './vertex.js';

import Edge from './edge.js';

import Graph from './graph.js';

export default Flow = (function() {
  class Flow extends BaseModel {
    constructor(attrs) {
      super(attrs);
      this.vertices = _.map(attrs.vertices || [], function(vertex_attrs) {
        return new Vertex(vertex_attrs);
      });
      this.edges = _.map(attrs.edges || [], function(edge_attrs) {
        return new Edge(edge_attrs);
      });
      this._makeFields(attrs.fields || [], attrs.logic_settings);
      if (attrs.graphs) {
        this._makeGraphs(attrs.graphs);
      }
      this.enable_identity_vertify = attrs.enable_identity_vertify;
    }

    getFieldById(field_id) {
      var _child, field, i, len, ref;
      ref = this.getAllFieldsInFlow();
      for (i = 0, len = ref.length; i < len; i++) {
        field = ref[i];
        if (field.id === field_id) {
          return field;
        }
        if (field.type.demodulize() === 'Detail') {
          _child = _.find(field.children, function(child) {
            return child.id === field_id;
          });
          if (_child) {
            return _child;
          }
        }
      }
    }

    getAllFieldsInFlow() {
      return this.fields.concat(_.flatten(this.graph.getChildrenGraphs().concat(this.graph).map(function(graph) {
        return graph.getOwnFields();
      }), true));
    }

    release() {
      return Ajax.patch(`/admin/yet_another_workflow/flows/${this.id}/release`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json'
      });
    }

    update() {
      if (this.isNew()) {
        return false;
      }
      return Ajax.patch(`/admin/yet_another_workflow/flows/${this.id}`, {
        data: {
          flow: this.toJSON()
        },
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: (data) => {
          return this._makeFields(data.fields || [], data.logic_settings);
        }
      });
    }

    toJSON() {
      return _.tap(super.toJSON(), (obj) => {
        return obj.fields_attributes = this._generateFieldAttributes();
      });
    }

    findVertexById(vertex_id) {
      return this.graph.findVertexById(vertex_id);
    }

    findGraphById(graph_id) {
      return this.graph.findGraphById(graph_id);
    }

    isFirstRelease() {
      return this.status !== 'active';
    }

    generateGraph(graphs, vertices, edges) {
      var graph, hierarchy;
      // add new vertices and edges
      vertices = _.map(vertices || [], function(vertex_attrs) {
        return new Vertex(vertex_attrs);
      });
      edges = _.map(edges || [], function(edge_attrs) {
        return new Edge(edge_attrs);
      });
      this.vertices = this.vertices.concat(vertices);
      this.edges = this.edges.concat(edges);
      this._resetGroupedVerticesAndEdges();
      hierarchy = new Hierarchy(graphs);
      graph = this._makeGraph(hierarchy.trees[0].root);
      return graph;
    }

    _makeGraphs(graphs_attrs) {
      var hierarchy;
      if (graphs_attrs.length) {
        hierarchy = new Hierarchy(graphs_attrs);
        return this.graph = this._makeGraph(hierarchy.trees[0].root);
      } else {
        return this.graph = null;
      }
    }

    _makeGraph(graph_node) {
      var graph, graph_attrs;
      graph_attrs = _.extend({
        flow: this
      }, graph_node._attrs);
      graph = new Graph(graph_attrs);
      _.each(this._getVerticesByGraph(graph), function(vertex) {
        return graph.insertVertex(vertex);
      });
      _.each(this._getEdgesByGraph(graph), (edge) => {
        edge.from = _.findWhere(this.vertices, {
          id: edge.from_vertex_id
        });
        edge.to = _.findWhere(this.vertices, {
          id: edge.to_vertex_id
        });
        return graph.insertEdge(edge);
      });
      _.each(graph_node.children, (child_node) => {
        return graph.addChild(this._makeGraph(child_node));
      });
      return graph;
    }

    _getVerticesByGraph(graph) {
      if (this._groupedVertices == null) {
        this._groupedVertices = _.groupBy(this.vertices, 'graph_id');
      }
      return this._groupedVertices[graph.id] || [];
    }

    _getEdgesByGraph(graph) {
      if (this._groupedEdges == null) {
        this._groupedEdges = _.groupBy(this.edges, 'graph_id');
      }
      return this._groupedEdges[graph.id] || [];
    }

    _resetGroupedVerticesAndEdges() {
      this._groupedVertices = null;
      return this._groupedEdges = null;
    }

  };

  Flow.setAttributes(['title', 'status', 'logic_settings', 'html_body', 'text_body', 'settings']);

  return Flow;

}).call(this);

Flow.assemble(Fieldable);
